import { useContext } from "react"
import FormContext from "./FormContextEventMltComplete"

const useGetFormContext = () => {
    return useContext(FormContext)
}

export default useGetFormContext